/**
 * ProdutoLocalRepository
 *
 * Abstrai o acesso aos produtos armazenados localmente via Electron IPC.
 */
import { getElectronAPI } from "@/plugins/desktop";

const ProdutoLocalRepository = {
  _api() {
    return getElectronAPI();
  },

  async getAll(filtros = {}) {
    return this._api().produtos.getAll(filtros);
  },

  async getById(id) {
    return this._api().produtos.getById(id);
  },

  async search(termo, id_grupo = null) {
    return this._api().produtos.search(termo, id_grupo);
  },

  async buscarPorCodigoBarras(codigo) {
    return this._api().produtos.buscarPorCodigoBarras(codigo);
  },

  async buscarExato(filtro) {
    return this._api().produtos.buscarExato(filtro);
  },

  // Alias explícito para busca por código exato (cod_barras / codigo / referencia / id)
  async buscarProdutoExato(termo) {
    return this._api().produtos.buscarExato(termo);
  },

  async salvarTodos(items) {
    return this._api().produtos.upsertMany(items);
  },

  async contar() {
    return this._api().produtos.contarProdutos();
  },

  async atualizarFiscal(id_produto, dados) {
    return this._api().produtos.atualizarFiscal(id_produto, dados);
  },
};

export default ProdutoLocalRepository;
